__turbopack_context__.v({
  "catalogBanner": "catalog-banner-module-scss-module__UlYrvq__catalogBanner",
  "img": "catalog-banner-module-scss-module__UlYrvq__img",
});
